module.exports = __webpack_public_path__ + "img/check_mark_accept_icon_grey.34ebd29f.svg";